import { FC } from 'react';
import TaxAdvantageAccountsPlan from 'model/TaxAdvantageAccountsPlan';
import EmployerContributionSection from 'modules/taxAdvantaged/components/EmployerContributionSection/EmployerContributionSection';
import ContributionField from 'modules/taxAdvantaged/components/ContributionField/ContributionField';
import { useAppSelector } from 'hooks/redux';
import {
  ANNUAL_MAX_CONTRIBUTION,
  END_OF_YEAR_POLICY,
} from 'constants/languageConstants';
import { getText } from 'utils/stringUtil';

import styles from './limitedPurposeFsaPlanInfo.module.less';

type Props = {
  plan: TaxAdvantageAccountsPlan;
};

const LimitedPurposeFsaPlanInfo: FC<Props> = (props: Props) => {
  const { plan } = props;
  const { employerContribution, maxYearlyContribution, endOfYearPolicy } = plan;
  const language = useAppSelector((state) => state.benguide.data?.language);

  return (
    <div className={styles.container}>
      {employerContribution && (
        <EmployerContributionSection
          className={styles.empContribution}
          employerContribution={employerContribution}
        />
      )}
      <div className={styles.subContainer}>
        {maxYearlyContribution !== null &&
          maxYearlyContribution !== undefined && (
            <ContributionField
              label={getText(ANNUAL_MAX_CONTRIBUTION, language)}
              value={maxYearlyContribution}
            />
          )}
        {endOfYearPolicy && (
          <ContributionField
            label={getText(END_OF_YEAR_POLICY, language)}
            valueText={endOfYearPolicy}
            valueEndOfYearPolicyField={true}
          />
        )}
      </div>
    </div>
  );
};

export default LimitedPurposeFsaPlanInfo;
